module.exports = "<p>\r\n  timer works!\r\n</p>\r\n"